"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateBy = void 0;
function aggregateBy(list, key, aggregation, retriever) {
    return list.reduce((previous, currentItem) => {
        const group = typeof key === "function" ? key(currentItem) : currentItem[key];
        switch (aggregation) {
            case "sum": {
                if (!previous.has(group)) {
                    previous.set(group, 0);
                }
                previous.set(group, previous.get(group) + retriever(currentItem));
                break;
            }
            case "push": {
                if (!previous.has(group)) {
                    previous.set(group, []);
                }
                previous.get(group).push(currentItem);
                break;
            }
            default: {
                aggregation;
            }
        }
        return previous;
    }, new Map());
}
exports.aggregateBy = aggregateBy;
//# sourceMappingURL=aggregate-by.js.map